<template>
  <v-navigation-drawer
    persistent
    :mini-variant="sidebarMinized"
    :clipped="clipped"
    v-model="navDrawer"
    fixed
    mini-variant-width="60"
    app
    class="main-menu"
    @input="input"
    >
    <v-toolbar flat color="white" height="50px">
      <!-- <img src="" class="logo-menu" :alt="title"> -->
    </v-toolbar>
    <v-divider></v-divider>
    <v-list class="menu-list">
      <v-list-tile exact :to="{ name: 'Dashboard' }" v-if="$can('Dashboard')">
        <v-tooltip lazy right>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">home</v-icon>
          </template>
          <span>Dashboard</span>
        </v-tooltip>
      </v-list-tile>
      <v-list-tile :to="{ name: 'Companies' }" v-if="$can('Companies')">
        <v-tooltip lazy right>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-domain</v-icon>
          </template>
          <span>Empresas</span>
        </v-tooltip>
      </v-list-tile>
      <v-list-tile :to="{ name: 'RecipientIndex' }" v-if="$can('RecipientIndex')">
        <v-tooltip lazy right>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-folder-open</v-icon>
          </template>
          <span>Destinatários</span>
        </v-tooltip>
      </v-list-tile>
      <v-list-tile :to="{ name: 'RecipientMultiples' }">
        <v-tooltip lazy right>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-file-upload</v-icon>
          </template>
          <span>Importar Destinatários</span>
        </v-tooltip>
      </v-list-tile>
      <v-list-tile :to="{ name: 'ServiceFiles' }" v-if="$can('ServiceFiles')">
        <v-tooltip lazy right>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">mdi-file-cabinet</v-icon>
          </template>
          <span>Arquivos de Serviço</span>
        </v-tooltip>
      </v-list-tile>
      <v-list-tile :to="{ name: 'Users', params: { group: 'administrator'} }" v-if="$can('Users')">
        <v-tooltip lazy right>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">supervisor_account</v-icon>
          </template>
          <span>Usuários</span>
        </v-tooltip>
      </v-list-tile>
      <v-list-tile :to="{ name: 'Financial' }" v-if="$can('Financial')">
        <v-tooltip lazy right>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">monetization_on</v-icon>
          </template>
          <span>Financeiro</span>
        </v-tooltip>
      </v-list-tile>
      <v-list-tile :to="{ name: 'Configuration' }" class="config-menu" v-if="$can('Configuration')">
        <v-tooltip lazy right>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">settings</v-icon>
          </template>
          <span>Configurações</span>
        </v-tooltip>
      </v-list-tile>
      <!-- <v-list-tile  v-for="menu in getMenu" :key="menu.title" :to="{name: menu.name, params: menu.params}" >
        <v-tooltip right>
          <v-icon slot="activator">{{ menu.icon }}</v-icon>
          <span>{{ menu.title }}</span>
        </v-tooltip>
      </v-list-tile> -->
    </v-list>

  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'MainMenu',
  props: {
    drawer: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      title: 'Modera',
      sidebarMinized: true, // minized sidebar
      clipped: false,
      navDrawer: this.drawer
    }
  },
  computed: {
    // ...mapGetters('menu', ['getMenu']),
    // ...mapGetters('global', ['getMiniLogo'])
  },
  watch: {
    drawer (value) {
      this.navDrawer = value
    }
  },
  methods: {
    input (value) {
      this.$emit('changeValue', value)
    }
  }
}
</script>

<style lang="sass">
  @import '../assets/style/variables'

  .v-navigation-drawer.main-menu
    z-index: 9

    // &.navigation-drawer--is-mobile.navigation-drawer--open
    //   z-index: 9

  .config-menu
    position: absolute
    bottom: 0
    left: 0
    width: 100%
    z-index: 2

  .menu-list

    .v-list__tile
      padding: 0

    a
      display: block
      text-align: center
      width: 100%

      .v-icon
        vertical-align: middle
        height: inherit

    .v-list__tile--active
      background-color: $gray

      .v-icon
        color: $accent
</style>
